/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RosettaErrorNoDetails,
    RosettaErrorNoDetailsFromJSON,
    RosettaErrorNoDetailsFromJSONTyped,
    RosettaErrorNoDetailsToJSON,
    RosettaOperationStatus,
    RosettaOperationStatusFromJSON,
    RosettaOperationStatusFromJSONTyped,
    RosettaOperationStatusToJSON,
} from './';

/**
 * Allow specifies supported Operation status, Operation types, and all possible error statuses. This Allow object is used by clients to validate the correctness of a Rosetta Server implementation. It is expected that these clients will error if they receive some response that contains any of the above information that is not specified here.
 * @export
 * @interface RosettaNetworkOptionsResponseAllow
 */
export interface RosettaNetworkOptionsResponseAllow {
    /**
     * All Operation.Status this implementation supports. Any status that is returned during parsing that is not listed here will cause client validation to error.
     * @type {Array<RosettaOperationStatus>}
     * @memberof RosettaNetworkOptionsResponseAllow
     */
    operation_statuses: Array<RosettaOperationStatus>;
    /**
     * All Operation.Type this implementation supports. Any type that is returned during parsing that is not listed here will cause client validation to error.
     * @type {Array<string>}
     * @memberof RosettaNetworkOptionsResponseAllow
     */
    operation_types: Array<string>;
    /**
     * All Errors that this implementation could return. Any error that is returned during parsing that is not listed here will cause client validation to error.
     * @type {Array<RosettaErrorNoDetails>}
     * @memberof RosettaNetworkOptionsResponseAllow
     */
    errors: Array<RosettaErrorNoDetails>;
    /**
     * Any Rosetta implementation that supports querying the balance of an account at any height in the past should set this to true.
     * @type {boolean}
     * @memberof RosettaNetworkOptionsResponseAllow
     */
    historical_balance_lookup: boolean;
}

export function RosettaNetworkOptionsResponseAllowFromJSON(json: any): RosettaNetworkOptionsResponseAllow {
    return RosettaNetworkOptionsResponseAllowFromJSONTyped(json, false);
}

export function RosettaNetworkOptionsResponseAllowFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaNetworkOptionsResponseAllow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'operation_statuses': ((json['operation_statuses'] as Array<any>).map(RosettaOperationStatusFromJSON)),
        'operation_types': json['operation_types'],
        'errors': ((json['errors'] as Array<any>).map(RosettaErrorNoDetailsFromJSON)),
        'historical_balance_lookup': json['historical_balance_lookup'],
    };
}

export function RosettaNetworkOptionsResponseAllowToJSON(value?: RosettaNetworkOptionsResponseAllow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'operation_statuses': ((value.operation_statuses as Array<any>).map(RosettaOperationStatusToJSON)),
        'operation_types': value.operation_types,
        'errors': ((value.errors as Array<any>).map(RosettaErrorNoDetailsToJSON)),
        'historical_balance_lookup': value.historical_balance_lookup,
    };
}

